import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

const GENERIC_ERROR = "An error occurred, please try again later.";
const OWNER_REQUIRED_TITLE = "Contact an admin to perform this action.";

export default class extends Controller {
  static get targets() {
    return ["connectBtn", "ownerRequiredBtn"];
  }

  static get values() {
    return { tokenUrl: String, integrationUrl: String };
  }

  connect() {
    this.afterIntegrationRedirect = null;
    this.initializeOwnerRequiredBtns();

    if (!this.hasConnectBtnTarget) { return; }

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const redirectUri = params.get("redirect_uri");
    if (code && redirectUri) {
      this.afterIntegrationRedirect = redirectUri;
      this.requestLinkToken({ rippling_code: code });
    }
  }

  createLinkToken(event) {
    event.preventDefault();
    this.requestLinkToken();
  }

  requestLinkToken(body) {
    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify(body || {});

    fetch(this.tokenUrlValue, options).
      then(response => response.ok ? response.json() : Promise.reject(response)).
      then(({ link_token }) => this.initializeMerge(link_token)).
      catch(() => this.showError());
  }

  initializeMerge(linkToken) {
    if (!linkToken) {
      this.showError();
      return;
    }

    MergeLink.initialize({
      linkToken: linkToken,
      onSuccess: (publicToken) => this.finishIntegration(publicToken),
      shouldSendTokenOnSuccessfulLink: true,
    });
    MergeLink.openLink();
  }

  finishIntegration(publicToken) {
    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({ public_token: publicToken });

    fetch(this.integrationUrlValue, options).
      then(response => response.ok ? response.json() : Promise.reject(response)).
      then(({ url }) => { window.location = this.afterIntegrationRedirect || url; }).
      catch(() => this.showError());
  }

  showError() {
    window.ltAlert({ message: GENERIC_ERROR, type: "toast-error" });
  }

  initializeOwnerRequiredBtns() {
    this.ownerRequiredBtnTargets.filter(btn => btn.hasAttribute("disabled")).forEach(btn => {
      if (!btn.getAttribute("title")) {
        btn.setAttribute("title", OWNER_REQUIRED_TITLE);
      }
      $(btn).tooltip(); // Bootstrap jQuery plugin, stays on jQuery's side
      // Hack so that the tooltip shows up on disabled buttons
      btn.style.pointerEvents = "auto";
      btn.addEventListener("click", (event) => event.preventDefault());
    });
  }
}
